import { createFileRoute } from "@tanstack/react-router";
import {
  Download,
  FlaskConical,
  ClipboardCheck,
  GitBranch,
  Database,
  SprayCan,
} from "lucide-react";
import { SecondaryNav } from "@client/components/secondary-nav";
import { useNavPermissions } from "@client/hooks/use-nav-permissions";

export const Route = createFileRoute("/_app/data-center")({
  component: DataCenterLayout,
});

const dataCenterItems = [
  {
    title: "抽取模板",
    to: "/data-center/tmpl" as const,
    icon: GitBranch,
    permission: "datacenter-tmpl",
  },
  {
    title: "数据抽取",
    to: "/data-center/extraction" as const,
    icon: FlaskConical,
    permission: "datacenter-extraction",
  },
  {
    title: "审核工作台",
    to: "/data-center/review" as const,
    icon: ClipboardCheck,
    permission: "datacenter-review",
  },
  { title: "导出管理", to: "/data-center/exports" as const, icon: Download, permission: "datacenter-export" },
  { title: "数据源", to: "/data-center/datasources" as const, icon: Database, permission: "datacenter-datasource" },
  { title: "数据清洗", to: "/data-center/cleaning" as const, icon: SprayCan, permission: "datacenter-cleaning" },
];

function DataCenterLayout() {
  const permSet = useNavPermissions();

  const items = dataCenterItems.filter((item) => {
    if (!item.permission) return true;
    return permSet.has(item.permission);
  });

  return <SecondaryNav title="数据中心" items={items} />;
}
